<script setup>
import Icon from 'next/icon/Icon.vue';

defineProps({
  label: { type: String, required: true },
  icon: { type: String, default: null },
});

const emit = defineEmits(['select']);

// Same tree-line connector as SidebarGroupLeaf so the fold toggle closes the
// group's tree instead of floating beside it.
const TREE_CONNECTOR =
  "child-item before:content-[''] before:absolute before:start-0 before:w-0.5 before:h-full before:bg-n-slate-4 first:before:rounded-t last:before:h-1/5 last:after:content-[''] last:after:absolute last:after:start-0 last:after:bottom-[calc(50%_-_2px)] last:after:h-3 last:after:w-2.5 last:after:border-b-2 last:after:border-s-2 last:after:rounded-es last:after:border-n-slate-4";
</script>

<template>
  <li
    class="py-0.5 ps-2 ms-3 relative text-n-slate-11 min-w-0"
    :class="TREE_CONNECTOR"
  >
    <button
      type="button"
      class="flex h-8 w-full items-center gap-3 rounded-lg px-2 transition-colors hover:bg-n-alpha-2 hover:text-n-slate-12"
      @click="emit('select')"
    >
      <span v-if="icon" class="size-4 grid place-content-center">
        <Icon :icon="icon" class="size-3.5 inline-block" />
      </span>
      <span class="flex-1 truncate text-start text-xs font-medium">
        {{ label }}
      </span>
    </button>
  </li>
</template>
